(() => {
  'use strict';
  const dimension = (title) => {
    const m = title.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)/i);
    return m ? `${Number(m[1])} × ${Number(m[2])} cm` : title;
  };
  document.querySelectorAll('[data-quick-compare]').forEach((root) => {
    let data;
    try { data = JSON.parse(root.querySelector('[data-haley-sales-catalog]').textContent); } catch { return; }
    const select = root.querySelector('[data-compare-size]');
    const sizes = [...new Set(data.products.flatMap(p => p.variants.filter(v => v.available).map(v => dimension(v.title))))].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    sizes.forEach(size => select.add(new Option(size, size)));
    select.addEventListener('change', () => {
      data.products.forEach(product => {
        const card = root.querySelector(`[data-compare-product="${product.handle}"]`);
        const variant = product.variants.filter(v => v.available && (!select.value || dimension(v.title) === select.value)).sort((a,b) => a.price-b.price)[0];
        const link = card.querySelector('[data-compare-link]');
        card.querySelector('[data-compare-variant]').textContent = variant?.title || select.value;
        card.querySelector('[data-compare-price]').textContent = variant?.priceLabel || data.strings.unavailable_size;
        const estimate = card.querySelector('[data-compare-estimate]');
        estimate.textContent = variant && data.currency === 'HKD' && variant.price >= 400000 ? `${data.strings.promo_estimate} ${new Intl.NumberFormat('en-HK', {style:'currency',currency:'HKD'}).format((variant.price-150000)/100)}` : '';
        const url = new URL(product.url, window.location.origin);
        if (variant) url.searchParams.set('variant', variant.id);
        link.href = url.href;
        link.dataset.croVariant = variant ? String(variant.id) : '';
      });
      document.dispatchEvent(new CustomEvent('haley:track', { detail: {event:'compare_size_select', placement:'same_size_compare'} }));
    });
  });
})();
